
    import './styles.scoped.css';
    export default {
  "button": "awsui_button_m5h9f_11nve_99",
  "expanded": "awsui_expanded_m5h9f_11nve_154",
  "offset-right-none": "awsui_offset-right-none_m5h9f_11nve_165",
  "offset-right-l": "awsui_offset-right-l_m5h9f_11nve_168",
  "offset-right-xxl": "awsui_offset-right-xxl_m5h9f_11nve_171",
  "text": "awsui_text_m5h9f_11nve_196",
  "icon": "awsui_icon_m5h9f_11nve_200"
};
  